import Modal from '../../../components/Modal/Modal';
import Cars from '../../Car/Cars';
import Equipments from '../../Equipments/Equipments';

const DealCreateEquipmentsModal = ({ isOpen, onClose, onSubmit, onCancel, containerId, carId, cityId }) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={onCancel}>
      <Equipments
        header={false}
        onSubmit={onSubmit}
        onCancel={onCancel}
        withCount
        withCheckboxes={false}
        edit={false}
        submitButtonLabel="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ"
        containerId={containerId}
        carId={carId}
        cityId={cityId}
        addEquipmentInModal
      />
    </Modal>
  );
};

export default DealCreateEquipmentsModal;
